// Django auth configuration - simplified version without MSAL

// Use defaults for Django auth - auth is handled by AuthContext
export const useLogin = true;
export const requireAccessControl = false;
export const enableUnauthenticatedAccess = true;
export const requireLogin = false;

// Django auth uses JWT tokens from AuthContext, not MSAL
export const isUsingAppServicesLogin = false;

// Stub functions for compatibility with existing components
// These are not used with Django auth, but needed to avoid import errors
export const getToken = async (_client: any): Promise<string | undefined> => {
    // With Django auth, tokens are managed by AuthContext and authFetch
    // This function is not used
    return undefined;
};

export const getUsername = async (_client: any): Promise<string | null> => {
    // With Django auth, username is in AuthContext
    return null;
};

export const getTokenClaims = async (_client: any): Promise<Record<string, unknown> | undefined> => {
    // With Django auth, claims are in AuthContext
    return undefined;
};

export const appServicesLogout = () => {
    // With Django auth, logout is handled by AuthContext
};

export const checkLoggedIn = async (_client: any): Promise<boolean> => {
    // With Django auth, login status is in AuthContext
    return false;
};
